import React from "react";
import { Nav, NavItem, NavList } from "@patternfly/react-core";
import useReactRouter from "use-react-router";
import { Link } from "react-router-dom";

export default () => {
  const { location } = useReactRouter();

  function isActive(path) {
    const re = new RegExp("^/product/" + path);
    return !!location.pathname.match(re);
  }

  return (
    <Nav variant="tertiary">
      <NavList>
        <NavItem isActive={isActive("list")} to="">
          <Link to={`/product/list`}>Product</Link>
        </NavItem>
        {/* <NavItem isActive={isActive("suite")} to="">
          <Link to={`/product/suite`}>Product Suite</Link>
        </NavItem> */}
        <NavItem isActive={isActive("group")} to="">
          <Link to={`/product/group`}>Product Group</Link>
        </NavItem>
      </NavList>
    </Nav>
  );
};
